import React from "react";
import AdminPanel from "../../components/AdminPanel";
// import AdminPanel from "../components/AdminPanel";

function Admin() {
  return (
    <div className="w-full">
      <AdminPanel />
    </div>
  );
}

export default Admin;
